import { clsx } from 'clsx'
import { useContext } from 'react'
import * as styles from './index.css'
import { SpoilerContext } from './SpoilerContext'

export interface SpoilerHeaderProps {
  className?: string
  toggleOnClick?: boolean
  children: (toggle: () => void, state: 'fold' | 'expand') => React.ReactNode
  onClick?: React.DOMAttributes<HTMLDivElement>['onClick']
}

export const SpoilerHeader = (props: SpoilerHeaderProps) => {
  const context = useContext(SpoilerContext)
  if (!context) {
    throw new Error('SpoilerHeader must be used within <SpoilerContainer>')
  }

  const onClick: React.DOMAttributes<HTMLDivElement>['onClick'] = (event) => {
    if (props.toggleOnClick) {
      context.toggle()
    }
    if (props.onClick) {
      props.onClick(event)
    }
  }

  return (
    <div
      className={clsx(styles.header, props.className)}
      onClick={onClick}
    >
      {props.children(context.toggle, context.state)}
    </div>
  )
}
